import { render, staticRenderFns } from "./WordCounter.vue?vue&type=template&id=434c2297&"
import script from "./WordCounter.vue?vue&type=script&lang=js&"
export * from "./WordCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports